import { useForm } from "react-hook-form"

import { zodResolver } from "@hookform/resolvers/zod"
import z from "zod"

import { AdminTeamLeaveOverlayProps } from "../AdminTeamLeaveOverlay"
import { AdminTeamLeaveOverlayViewProps } from "../ui/AdminTeamLeaveOverlayView"
import { AdminTeamLeaveFormData } from "./useTeamLeaveOverlayModel"

const AdminTeamLeaveFormSchema = z.object({
  memberID: z.string().min(1)
})

export function useAdminTeamLeaveOverlayViewModel({
  teamMemberOptions,
  hasPendingInvites,
  wasLastAdmin,
  onSubmit,
  onCancel
}: AdminTeamLeaveOverlayProps): AdminTeamLeaveOverlayViewProps {
  const form = useForm<AdminTeamLeaveFormData>({
    defaultValues: {
      memberID: ""
    },
    resolver: zodResolver(AdminTeamLeaveFormSchema)
  })

  const handleSubmit = form.handleSubmit(onSubmit)

  return {
    form,
    teamMemberOptions,
    hasNoCandidates: hasPendingInvites && teamMemberOptions.length === 0,
    wasLastAdmin,
    onSubmit: handleSubmit,
    onCancel
  }
}
